import React, { useState } from "react";

import "./styles.css";
import logoCetim from "../../assets/images/logo_cetim_carnot.svg";
import pictoIa from "../../assets/images/picto-ia.png";

const svgContainerStyle = { width: '25px', flexShrink: 0 }; // flexShrink pour éviter que le conteneur SVG ne rétrécisse
const nouveauteTitleStyle = { height: '24px' }; // Hauteur spécifique pour le titre

const Infoia = ({ createLink, connectLink, onOpen, onConnect, onCreateAccount }) => { 

  // Ouverte par défaut la première fois ; une fois fermée par l'utilisateur, on mémorise pour ne plus la rouvrir automatiquement
  const [isOpen, setIsOpen] = useState(() => localStorage.getItem('infoiaDismissed') !== 'true');

  const toggleOpen = () => {
    const nextOpen = !isOpen;
    setIsOpen(nextOpen);

    if (!nextOpen) {
      localStorage.setItem('infoiaDismissed', 'true');
    }

    if (onOpen && nextOpen) {
      onOpen();
    }
  }
    
  return (
    <div>
      {!isOpen ? (
            <div id="chatbot-button-open" className="bulle" onClick={toggleOpen}>
                  <img className="" src={pictoIa} alt="chatbot" />
              </div>
        ) : (
                <div>
              <div id="chatbot-modal-disconnected">

                    <span
                      className="chatbot-modal-close"
                      onClick={toggleOpen}
                      role="button"
                      aria-label="Fermer"
                    >
                      &times;
                    </span>

                      <img
                src={logoCetim}
                alt="Logo Cetim"
                className="logo-cetim"
              />
            
                  <div className="d-flex flex-row">
                    <div style={svgContainerStyle} className="me-3">
                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12.5" cy="12.5" r="12.5" fill="#EF3346"></circle>
                        <path d="M14.4395 13.3945H11.7427V16.0914H14.4395V13.3945Z" fill="white"></path>
                        <path d="M5 10.6978V16.0915H7.69686V13.3946H11.7425V10.6978H5Z" fill="white"></path>
                        <path d="M18.1051 8.00081H11.7427V10.6977H17.1364V16.0914H19.8332V9.72811C19.8332 8.77387 19.0594 8 18.1051 8V8.00081Z" fill="white"></path>
                      </svg>
                    </div>

                    <div className="d-flex flex-column flex-grow-1">

                      <div className="d-flex flex-column mb-4">
                        <div className="text-custom-primary font-sourcesanspro d-flex flex-column">
                          <div
                            className="fw-bold lh-base mb-2"
                            style={nouveauteTitleStyle}
                          >
                            Nouveauté
                          </div>
                          <div className="lh-base" style={{ fontSize: '16px', lineHeight: '24px', fontWeight: '600' }}>
                            Découvrez l’IA générative de la Mécathèque qui simplifie vos recherches. Connectez-vous avec votre compte ressortissant pour y accéder. (accès réservé aux ressortissants)
                          </div>
                        </div>
                      </div>

                      <div className="d-flex flex-row gap-3 justify-content-between">
                        <a
                          href={connectLink}
                          className="btn-custom btn-custom-blue w-100 rounded-1 fw-bold text-uppercase lh-1 font-sourcesanspro"
                          role="button"
                          onClick={(e) => {
                            if (onConnect) {
                              onConnect(connectLink);
                            }
                          }}
                        >
                          Me connecter
                        </a>

                        <a
                          href={createLink}
                          className="btn-custom btn-custom-red w-100 rounded-1 fw-bold text-uppercase lh-1 font-sourcesanspro"
                          role="button"
                          onClick={(e) => {
                            if (onCreateAccount) {
                              onCreateAccount(createLink);
                            }
                          }}
                        >
                          Créer un compte
                        </a>
                      </div>
                    </div>
                  </div>
                </div>          
              </div>
            )}
          </div>
  );
}

export default Infoia;
